import axios from 'axios'

export default {
  login (user) {
    return axios.post('/login_check', user)
  }
}
